import React from 'react';
import classNames from 'classnames';
import { Listing } from 'models/Listing';
import ResolveImage from 'components/ResolveImage';
import { Link } from 'react-router-dom';
import { getImgUrl, RESIZED_WIDTH } from 'components/ResolveImage/utils';
import utils, { mapValueToMoneyFormat } from 'utils';
import useLocationMapper from 'router/data/useLocationMapper';
import { useTranslation } from 'react-i18next';

import './ListingCardOnPrivateListingLanding.styles.scss';

type ListingCardOnPrivateListingLandingProps = {
  className?: string;
  listing: Listing;
};

const ListingCardOnPrivateListingLanding: React.FC<
  ListingCardOnPrivateListingLandingProps
> = (props) => {
  const { className, listing } = props;

  const {
    gallery,
    industry,
    slugName,
    type,
    revenue,
    listingTitle,
    location,
    dealLocation,
  } = listing;

  const classes = classNames(
    'listing-card-on-private-listing-landing',
    className,
  );

  const { locationLabelMapper } = useLocationMapper();

  const redirectionListingLink = utils.composeBusinessUrl(
    industry,
    slugName,
    type,
  );

  const { t } = useTranslation();

  return (
    <Link
      to={redirectionListingLink}
      className="listing-card-on-private-listing-landing-wrapper"
    >
      <div className={classes}>
        <div>
          <p className="title">{listingTitle}</p>
          <p className="state-industry">
            <span>{locationLabelMapper[location?.state] || dealLocation}</span>
            <span className="industry">{industry}</span>
          </p>
          {!!revenue && (
            <p className="revenue">
              {mapValueToMoneyFormat(revenue)}
              <span>{t('revenue')}</span>
            </p>
          )}
        </div>
        <ResolveImage
          alt="Listing"
          src={getImgUrl(gallery[0]?.url, RESIZED_WIDTH[240])}
        />
      </div>
    </Link>
  );
};

export default ListingCardOnPrivateListingLanding;
